import { AvailableCard } from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking";

import { useLockSlots } from "../../../../../../../features/LockSlots";

type EmptySlotProps = {
  durationMins: number;
  slotId: string;
  time: string;
  startDateTime?: string | null;
  courseName: string;
  handleMultiSlotRowPress?: (slotId: string) => void;
  isAvailable?: boolean;
  setBookingWizardSlotId?: (slotId: string) => void;
  setBookingWizardStartTime?: (startTime: string) => void;
};

export const EmptySlot = ({
  durationMins,
  slotId,
  time,
  startDateTime,
  courseName,
  handleMultiSlotRowPress,
  isAvailable,
  setBookingWizardSlotId,
  setBookingWizardStartTime,
}: EmptySlotProps) => {
  const [handleLockSlot] = useLockSlots();

  const handleSlotSelection = () => {
    if (!isAvailable) return;
    if (setBookingWizardSlotId && setBookingWizardStartTime) {
      handleLockSlot({ timeSlotIds: [slotId] }, () => {
        setBookingWizardSlotId(slotId);
        setBookingWizardStartTime(startDateTime ?? time);
      });
    } else if (slotId && handleMultiSlotRowPress) {
      handleMultiSlotRowPress(slotId);
    }
  };

  return (
    <AvailableCard
      durationMins={durationMins}
      onPress={handleSlotSelection}
      courseName={courseName}
      time={time}
    />
  );
};
